import React from 'react'

const ArabicLogo = (): JSX.Element => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="21"
                height="21"
                rx="10.5"
                stroke="white"
            />
            <mask
                id="mask0_483_2472"
                maskUnits="userSpaceOnUse"
                x="1"
                y="1"
                width="20"
                height="20"
            >
                <circle cx="11" cy="11" r="10" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_483_2472)">
                <path
                    d="M30.9935 7.66602H1V14.3306H30.9935V7.66602Z"
                    fill="white"
                />
                <path d="M30.9935 1H1V7.66646H30.9935V1Z" fill="#009E49" />
                <path
                    d="M30.9935 14.333H1V20.9995H30.9935V14.333Z"
                    fill="black"
                />
                <path d="M8.76893 1H1V20.9975H8.76893V1Z" fill="#CE1126" />
            </g>
        </svg>
    )
}

export default ArabicLogo
